// extracted by mini-css-extract-plugin
export default {"container":"OverlayedImage_container__9j-Mo","overlay_img":"OverlayedImage_overlay_img__aaDK4"};